// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"c2df6996","455":"be8df251","488":"0fc171a2","977":"965fac80"}[chunkId] + ".chunk.js";
};